export default "/_next/static/sounds/CASE_SELECT-2a2ee3b91a0286ae0f73aa26311168c9.mp3";